import { AttributeType } from "@evergis/api";
import { DEFAULT_ID_ATTRIBUTE_NAME, GEOMETRY_ATTRIBUTE } from "../../constants";

export const geometryTypes: AttributeType[] = [
  AttributeType.Point,
  AttributeType.Polyline,
  AttributeType.MultiPolygon,
  AttributeType.Multipoint,
];

export const systemAttributesName = [DEFAULT_ID_ATTRIBUTE_NAME, GEOMETRY_ATTRIBUTE];

export function isSystemAttribute<Attribute extends { attributeName?: string; originalName?: string }>(
  attribute?: Attribute,
) {
  return systemAttributesName.includes(attribute.attributeName || attribute.originalName);
}

export function filterGeometryAttributes<Attribute extends { type?: AttributeType }>(
  attributes?: Attribute[],
): Attribute[] {
  return attributes ? attributes.filter(({ type }) => !isGeometryType(type)) : [];
}

export function getGeometryAttributes<Attribute extends { type?: AttributeType; expression?: string }>(
  attributes?: Attribute[],
): Attribute[] {
  return attributes ? attributes.filter(({ type, expression }) => isGeometryType(type) && !expression) : [];
}

export function isGeometryType(attributeType: AttributeType): boolean {
  return geometryTypes.includes(attributeType);
}
